import React, { useState } from "react";
import clsx from "clsx";
import s from "./Accordion.less";

const Accordion = ({ title = "ДОПОЛНИТЕЛЬНАЯ ИНФОРМАЦИЯ", children }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleAccordion = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={s.accordion}>
      <div
        className={s.accordionHeader}
        onClick={toggleAccordion}
        style={{
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "10px 0",
          borderRadius: "4px",
        }}
      >
        <span className={s.title}>{title}</span>
        {!isExpanded ? (
          <div className={s.wrap}>
            <div className={s.icon}>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="16" height="16" rx="8" fill="#4D5965" />
                <path
                  d="M8 4V12M4 8L12 8"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            Развернуть
          </div>
        ) : (
          <div className={s.wrap}>
            <div className={s.icon}>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="16" height="16" rx="8" fill="#4D5965" />
                <path
                  d="M4 8L12 8"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>{" "}
            Свернуть
          </div>
        )}
      </div>
      <div
        className={s.accordionContent}
        style={{
          padding: isExpanded ? "10px 0" : "0",
          borderTop: "none",
          height: isExpanded ? "auto" : "0",
          overflow: isExpanded ? "initial" : "hidden",
          transition: "all 0.2s ease",
        }}
      >
        {isExpanded && children}
      </div>
    </div>
  );
};

export default Accordion;
